module.exports = __webpack_public_path__ + "img/13.006ad19.png";